import React from "react";
import { Text, Image, TouchableOpacity, View } from "react-native";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { s } from "react-native-size-matters";
import { AppImages } from "../../utility/AppImages";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";

const GameComponent = ({ game, isSelected, onSelectionChange, styles }) => {
  const deviceSize = useDeviceSize();
  const isMobile = deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM;

  return (
    <TouchableOpacity
      style={[
        {
          marginBottom: isMobile ? s(6) : s(10),
          alignItems: "center",
        },
      ]}
      activeOpacity={0.8}
      onPress={() => onSelectionChange(!isSelected)} // Toggle selection
    >
      <View
        style={[
          {
            display: "flex",
            width: isMobile ? 106 : 143,
            padding: isMobile ? 3 : 4,
            paddingHorizontal: isMobile ? 3 : 6,
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: 3,
            borderWidth: 1,
            borderColor: isSelected ? "#DC2626" : "transparent",
            backgroundColor: isSelected
              ? "rgba(220, 38, 38, 0.10)"
              : "transparent",
            borderRadius: 8,
            overflow: "hidden",
          },
        ]}
      >
        <Image
          source={{ uri: game.source }}
          style={{
            height: isMobile ? 95 : 124,
            width: "100%",
            borderRadius: 8,
          }}
          resizeMode="cover"
        />
        {isSelected && (
          <View
            style={{
              width: 15,
              height: 15,
              borderRadius: 50,
              backgroundColor: "#DC2626",
              position: "absolute",
              top: 8,
              right: 8,
            }}
          />
        )}
        <Text
          style={{
            color: "#FFF",
            fontSize: isMobile ? 13 : 16,
            fontWeight: "600",
            lineHeight: isMobile ? 16 : 20,
          }}
          numberOfLines={1}
        >
          {game.title}
        </Text>
      </View>
    </TouchableOpacity>
  );
};

export default GameComponent;
